<template>
  <v-dialog
    v-model="dialog"
    max-width="350"
  >
    <template #activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon small>
          fas fa-trash
        </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <v-icon
          color="red"
          class="pr-2"
          small
        >
          fas fa-trash
        </v-icon>
        Confirm to delete
      </v-card-title>
      <v-card-text>
        Please confirm to delete <span class="font-weight-bold font-italic">{{ task.name }}</span> task.
      </v-card-text>
      <v-alert
        v-if="errorMsg !== ''"
        type="error"
      >
        {{ errorMsg }}
      </v-alert>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          text
          color="error"
          :loading="loading"
          :disabled="countDown !== 0"
          @click="deleteTask"
        >
          <span
            v-if="countDown !== 0"
            class="blue--text"
          > {{ countDown }}</span>
          <span v-else>Delete</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { scheduler } from '@rhitics/core'
import { interval } from 'rxjs'

const CAN_DELETE_SECOND = 4

export default {
  nmae: 'TaskDeleteDialog',

  props: {
    task: {
      type: Object,
      default: undefined
    }
  },

  data() {
    return {
      dialog: false,
      loading: false,
      countDown: 0,
      errorMsg: '',
      intervalId: 0
    }
  },

  watch: {
    dialog() {
      if (this.dialog) {
        this.countDown = CAN_DELETE_SECOND
        this.intervalId = setInterval(() => {
          if (this.countDown === 0) {
            clearInterval(this.intervalId)
          } else {
            this.countDown--
          }
        }, 1000)
      } else {
        clearInterval(this.intervalId)
      }
    }
  },

  methods: {
    async deleteTask() {
      const id = this.task.id
      this.loading = true
      try {
        await scheduler.task.delete(id)
        this.$emit('update')
        this.dialog = false
      } catch (error) {
        this.errorMsg = error.message
      }
      this.loading = false
    }
  }
}
</script>
